module.exports = __webpack_public_path__ + "files/9f5bb79481b260522598e577aa23fe7b.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/activity.png
// module id = 587
// module chunks = 59